export default __webpack_public_path__ + "ee9bffc0b606a93b3effb967d127d0dd.png";